<template>
  <li class="side-nav-link"
      v-bind:class="active_category == category_data.id ? 'active' : '' "
      @click="makeMeActive">
    <div class="row">
      <div class="col-9">{{category_data.name}}</div>
      <div class="col-3">
        <b-badge pill v-if="getTotalRequired()" :class="setClass()" class="float-right completion">
          {{getTotalComplete(true)}} / {{getTotalRequired()}}
        </b-badge>
        <b-badge pill v-else :class="setClass()">
          Optional
        </b-badge>
      </div>
    </div>
<!--
comp: {{category_data.completed}}<br>
start:{{category_data.started}}<br>
error:{{category_data.error}}
-->
  </li>
</template>

<script>
export default {
  props:{
    active_category: Number,
    category_data: Object
  },
  data(){
    return{
      active: false,
      totalRequired: null,
      totalComplete: null
    }
  },
  methods:{
    makeMeActive(){
      this.$parent.$emit('updateActiveCategory', this.category_data.id)
    },
    getTotalComplete(required = false) {
      var totalComplete = 0
      for (var q in this.category_data.questions) {
        var question = this.category_data.questions[q]
        if ((question.validation && question.validation.required) || !required) {
          if (question.repeatable) {
            if (Array.isArray(question.answer.value)) {
              for (var r = 1; r < question.answer.value.length; r++) {
                var tag = question.answer.value[r].id[question.answer.value[r].id.length - 1]
                var valid = true
                for (var e in question.answer.errors) {
                  var error = question.answer.errors[e]
                  if (error[error.length - 1] === tag) {
                    valid = false
                  }
                }
                if (valid) {
                  totalComplete += 1
                }
              }
            }
          } else if (question.question_type === "file_upload") { if (0 < question.answer.file_uploads.length) {
              totalComplete += 1
            }
          } else if (Array.isArray(question.answer.value)) {
            var complete = false
            for (var val in question.answer.value) {
              if (question.answer.value[val] != '0') {
                complete = true
              }
            }
            if (complete) { totalComplete += 1 }
          } else if (!question.answer.errors && question.answer.value) {
            totalComplete += 1
          }
        }
      }
      return totalComplete
    },
    getTotalRequired() {
      var totalRequired = 0
      for (var q in this.category_data.questions) {
        var question = this.category_data.questions[q]
        if (question.validation && question.validation.required) {
          if (question.repeatable) {
            totalRequired += Math.max(question.validation.required.minimum, (question.answer.value.length - 1))
          } else {
            totalRequired += 1
          }
        }
      }
      return totalRequired
    },
    setClass() {
      var totalRequired = this.getTotalRequired()
      var totalRequiredComplete = this.getTotalComplete(true)
      var totalComplete = this.getTotalComplete()
      if (totalRequiredComplete === totalRequired && !this.category_data.error && totalComplete > 0) {
        return "completed"
      } else if (totalComplete > 0 || (this.category_data.error && totalRequired === 0)) {
        return "in-progress"
      } else {
        return "not-started"
      }
    }
  }
}
</script>

<style lang="scss">
// $medium-grey: #acacac;
// $lighter-grey: #e0e0e0;
// $gold: #f4d02e;
// $black: #000;
$green: #00d000;
$danger: #ff4136;
$warning: #f4d02e;


// Left column menu
.nav-left ul li
{
  margin-left: -40px;
  list-style-type: none;
  border-bottom: 1px solid #999;
}

.nav-left ul .side-nav-link, .progress-bar-container {
  padding: 10px;
}

.nav-left ul li a
{
  color: #666;
  font-weight: 600;
  width: 100%;
  display: block;
  padding: 10px;
}

.nav-left ul li:last-child { border-bottom: none; }

.no-padding {
  padding: 0;
}

li a span {
  padding: 10px;
}

.error-color.side-error-notification {
    font-size: 1.5em;
}

.error-color {
    color: $danger;
}

.fa-check-circle.side-check-notification {
    font-size: 1.6em;
}

.green {
    color: $green;
}

.side-nav-link.active .error-color,
.side-nav-link:hover .error-color {
    color: $warning;
}

.completion {
  height: 2em;
  padding-top: 6px;
}

.completed {
  background-color: $green;
}

.in-progress {
  background-color: #FFBFBF;
  color:  #9F0000;
}

.not-started {
  border: 1px solid #9f9f9f;
  background-color: white;
  color: #9f9f9f;;
}

</style>
